import Main from './KpiMain'
import New from './KpiNew'
import Show from './KpiShow'
import Edit from './KpiEdit'

export default {
  Main,
  New,
  Show,
  Edit,
}
